import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  AFFILIATE_PROGRAM_TRACKERS_DOWNLOAD_LIST_MUTATION_KEY,
  AFFILIATE_PROGRAM_TRACKERS_LIST_REPORT_URL,
  AFFILIATE_PROGRAM_TRACKERS_PERMISSIONS,
} from '../constants';

export default function useDownloadAffiliateProgramTrackersReportMutation(): IContextMutationResult<
  void,
  Error,
  IDownloadListReportPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [AFFILIATE_PROGRAM_TRACKERS_DOWNLOAD_LIST_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      AFFILIATE_PROGRAM_TRACKERS_LIST_REPORT_URL,
      payload,
      { permission: AFFILIATE_PROGRAM_TRACKERS_PERMISSIONS.DOWNLOAD_LIST },
    ),
  });
}
